<app-navigazione-container [entrypoints]="entrypoints"></app-navigazione-container>